/**
 * Minimal SSE frame parser (event + data lines, blank-line delimited).
 * Shared by live credit-stream and Socket-API rate stream.
 *
 * Socket-API (and most HTTP stacks) delimit frames with CRLF. EventSource
 * normalizes that; a fetch reader must too or ticks never leave the buffer.
 */

export function parseSseChunk(
  buffer: string,
  onEvent: (name: string, data: string) => void,
): string {
  // Hold a trailing CR so an in-flight CRLF is not treated as a frame boundary.
  let holdCr = ''
  if (buffer.endsWith('\r')) {
    holdCr = '\r'
    buffer = buffer.slice(0, -1)
  }
  const normalized = buffer.replace(/\r\n/g, '\n')
  const parts = normalized.split('\n\n')
  const rest = (parts.pop() ?? '') + holdCr
  for (const block of parts) {
    if (!block.trim() || block.startsWith(':')) continue
    let eventName = 'message'
    const dataLines: string[] = []
    for (const line of block.split('\n')) {
      if (line.startsWith('event:')) eventName = line.slice(6).trim()
      else if (line.startsWith('data:')) dataLines.push(line.slice(5).trim())
    }
    if (dataLines.length) onEvent(eventName, dataLines.join('\n'))
  }
  return rest
}
